import useGetApi from 'src/api/useGetApi';

export interface CustomerLocationDTO {
  id: string;
  name: string | null;
  dunsNumber?: string | null;
  address: string | null;
  longitude: number | null;
  latitude: number | null;
  disabled: boolean;
}

interface GetCustomerLocationsResponse {
  locations: CustomerLocationDTO[];
}

interface UseCustomerLocationsOptions {
  activeOnly?: boolean;
  siteUseCode?: 'SHIP_TO' | 'BILL_TO';
}

const useCustomerLocations = (
  customerId: string,
  enabled = true,
  options?: UseCustomerLocationsOptions,
) => {
  const params = new URLSearchParams();
  if (options?.activeOnly) {
    params.set('activeOnly', 'true');
  }
  if (options?.siteUseCode) {
    params.set('siteUseCode', options.siteUseCode);
  }
  const queryString = params.toString() ? `?${params.toString()}` : '';
  return useGetApi<GetCustomerLocationsResponse>({
    endpoint: `accounts-receivable/customers/${customerId}/locations${queryString}`,
    options: {
      enabled: enabled && !!customerId,
    },
  });
};

export default useCustomerLocations;
